/* import __COLOCATED_TEMPLATE__ from './attribute-and-event-description-tooltip.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();